<template>
    <div>

        <div class="news-social-media">
            <p class="share">
                {{share}}
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
                <g>
                <path d="M234.667,170.844V96c0-17.646-14.354-32-32-32c-7.938,0-15.604,3.042-21.542,8.563l-13.771,12.74
			C122.042,127.229,46.188,197.396,7.375,236.323C2.625,241.115,0,248.094,0,256s2.625,14.885,7.375,19.688
			c38.813,38.917,114.667,109.083,159.979,151.01l13.771,12.74c5.938,5.521,13.604,8.563,21.542,8.563c17.646,0,32-14.354,32-32
			v-74.594c153.604,2.156,256,50.604,256,95.927c0,5.896,4.771,10.667,10.667,10.667c5.896,0,10.667-4.771,10.667-10.667
			C512,293.594,388.563,176.052,234.667,170.844z M224,320c-5.896,0-10.667,4.771-10.667,10.667V416
			c0,5.885-4.792,10.667-10.667,10.667c-3.25,0-5.625-1.563-7.042-2.875l-13.771-12.75C136.646,369.219,61,299.24,22.5,260.635
			c-0.583-0.583-1.167-2.25-1.167-4.635s0.583-4.052,1.167-4.625C61,212.76,136.646,142.781,181.854,100.958l13.771-12.75
			c1.417-1.313,3.792-2.875,7.042-2.875c5.875,0,10.667,4.781,10.667,10.667v85.333c0,5.896,4.771,10.667,10.667,10.667
			c128.25,0,235.646,83.729,261,194.885C439.479,347.01,340.917,320,224,320z" />
	</g>
</g>
</svg>
            </p>
            <div class="row">
                <div class="facebook">
                    <ShareNetwork network="facebook"
                                  key="facebook"
                                  :url="fullUrl"
                                  :title="sharing.title"
                                  :description="sharing.description">
                        <i class="icon-facebook"></i>
                    </ShareNetwork>
                </div>
                <div class="twitter">
                    <ShareNetwork network="twitter"
                                  key="twitter"
                                  :url="shortenUrl"
                                  :title="sharing.title"
                                  :description="sharing.description"
                                  :twitterUser="sharing.twitterUser">
                        <i class="icon-twitter"></i>
                    </ShareNetwork>
                </div>
                <div class="whatsapp">
                    <ShareNetwork network="whatsapp"
                                  key="whatsapp"
                                  :url="shortenUrl"
                                  :title="sharing.title"
                                  :description="sharing.description">
                        <i class="icon-whatsapp"></i>
                    </ShareNetwork>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import axios from 'axios';
    import Vue from 'vue';
    import ShareNetwork from 'vue-social-sharing'
    Vue.use(ShareNetwork);

    let pageURL = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
    let socialThis;

    export default {
        props: {
            titleToShareOnSocial: {
                type: String
            },
            descriptionToShareOnSocial: {
                type: String
            },
            share: {
                type: String
            }
        },
        data() {
            return {
                latestNews: [],
                sharing: {
                    url: '',
                    title: '',
                    description: ''
                },
                shortenUrl: "",
                fullUrl: "",
                networks: [
                    { network: 'facebook', name: 'Facebook', icon: 'icon-facebook' },
                    { network: 'whatsapp', name: 'Whatsapp', icon: 'icon-whatsapp' },
                    { network: 'twitter', name: 'Twitter', icon: 'icon-twitter' }
                ]
            }
        },
        methods: {},
        mounted() {
            socialThis = this;
            socialThis.sharing.title = socialThis.titleToShareOnSocial;
            socialThis.sharing.description = socialThis.descriptionToShareOnSocial;

            let pageUrlWithoutSpacing = pageURL.replaceAll("%20", "");

            socialThis.fullUrl = pageURL;

            axios.get(`https://tinyurl.com/api-create.php?url=${pageUrlWithoutSpacing}`)
                .then((res) => {
                    socialThis.shortenUrl = res.data;
                })
                .catch(() => {
                    socialThis.shortenUrl = pageURL;
                })
        }
    }
</script>
